(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-us-content"] && !Shopify.designMode) return;
  try {
    
(function() {
  const initProcessCarousel = () => {
    const section = document.querySelector('.process-section');
    if (!section) return;

    const emblaNode = section.querySelector('.process-embla');
    if (!emblaNode) return;

    if (typeof EmblaCarousel === 'undefined') {
      setTimeout(initProcessCarousel, 100);
      return;
    }

    const prevBtn = section.querySelector('.process-prev-btn');
    const nextBtn = section.querySelector('.process-next-btn');
    const progressBar = section.querySelector('.process-progress-bar');

    const embla = EmblaCarousel(emblaNode, {
      loop: false,
      align: 'start',
      containScroll: 'trimSnaps',
      dragFree: true 
    });

    const updateButtons = () => {
      if (prevBtn) {
        if (embla.canScrollPrev()) {
          prevBtn.removeAttribute('disabled');
        } else {
          prevBtn.setAttribute('disabled', 'true');
        }
      }
      if (nextBtn) {
        if (embla.canScrollNext()) {
          nextBtn.removeAttribute('disabled');
        } else {
          nextBtn.setAttribute('disabled', 'true');
        }
      }
    };

    if (prevBtn) prevBtn.addEventListener('click', () => embla.scrollPrev());
    if (nextBtn) nextBtn.addEventListener('click', () => embla.scrollNext());

    embla.on('select', updateButtons);
    embla.on('init', updateButtons);
    embla.on('reInit', updateButtons);

    const updateProgress = () => {
      const progress = Math.max(0, Math.min(1, embla.scrollProgress()));
      progressBar.style.width = `${progress * 100}%`;
    };

    embla.on('scroll', updateProgress);
    embla.on('init', updateProgress);
    embla.on('reInit', updateProgress);
    
    // Uruchomienie przy starcie
    updateButtons();
    updateProgress();
  };

  document.addEventListener('DOMContentLoaded', initProcessCarousel);
  document.addEventListener('shopify:section:load', initProcessCarousel);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-clients-slider"] && !Shopify.designMode) return;
  try {
    
(function() {
  const initB2BClients = () => {
    const section = document.querySelector('.b2b-clients-section');
    if (!section) return;
    const emblaNode = section.querySelector('.b2b-clients-embla');
    if (!emblaNode) return;
    if (typeof EmblaCarousel === 'undefined') {
      setTimeout(initB2BClients, 100);
      return;
    }
    const prevBtn = section.querySelector('.b2b-clients-prev');
    const nextBtn = section.querySelector('.b2b-clients-next');
    const dotsNode = section.querySelector('.b2b-clients-dots');
    const embla = EmblaCarousel(emblaNode, {
      loop: false,
      align: 'start',
      slidesToScroll: 1,
      containScroll: 'trimSnaps'
    });
    const updateArrows = () => {
      if (!prevBtn || !nextBtn) return;
      prevBtn.style.opacity = embla.canScrollPrev() ? '1' : '0';
      prevBtn.style.pointerEvents = embla.canScrollPrev() ? 'auto' : 'none';
      nextBtn.style.opacity = embla.canScrollNext() ? '1' : '0';
      nextBtn.style.pointerEvents = embla.canScrollNext() ? 'auto' : 'none';
    };
    if (prevBtn) prevBtn.addEventListener('click', embla.scrollPrev);
    if (nextBtn) nextBtn.addEventListener('click', embla.scrollNext);
    embla.on('select', updateArrows);
    embla.on('init', updateArrows);
    embla.on('reInit', updateArrows);
    if (dotsNode) {
      const scrollSnaps = embla.scrollSnapList();
      dotsNode.innerHTML = '';
      const dots = scrollSnaps.map((_, index) => {
        const dot = document.createElement('button');
        dot.classList.add('b2b-dot');
        dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
        dot.addEventListener('click', () => embla.scrollTo(index));
        dotsNode.appendChild(dot);
        return dot;
      });
      const updateDots = () => {
        const selectedIndex = embla.selectedScrollSnap();
        dots.forEach((dot, index) => {
          if (index === selectedIndex) dot.classList.add('b2b-dot--active');
          else dot.classList.remove('b2b-dot--active');
        });
      };
      embla.on('select', updateDots);
      embla.on('init', updateDots);
    }
  };
  document.addEventListener('DOMContentLoaded', initB2BClients);
  document.addEventListener('shopify:section:load', initB2BClients);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-offer-hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initEmbla() {
      const emblaNodes = document.querySelectorAll('.b2b-hero-embla');
      
      if (typeof EmblaCarousel === 'undefined') {
        console.warn('EmblaCarousel is not loaded yet, retrying...');
        setTimeout(initEmbla, 100);
        return;
      }

      emblaNodes.forEach(function(emblaNode) {
        if (emblaNode.dataset.emblaInitialized === 'true') {
          return;
        }

        if (!emblaNode) {
          return;
        }

        try {
          const loop = emblaNode.dataset.emblaLoop === 'true';
          const align = emblaNode.dataset.emblaAlign || 'start';
          const duration = parseInt(emblaNode.dataset.emblaDuration) || 20;
          const slidesToScroll = parseInt(emblaNode.dataset.emblaSlidesToScroll) || 1;
          const dragFree = emblaNode.dataset.emblaDragFree === 'true';

          const embla = EmblaCarousel(emblaNode, {
            loop: loop,
            align: align,
            duration: duration,
            slidesToScroll: slidesToScroll,
            dragFree: dragFree
          });

          if (!embla) {
            console.error('Failed to initialize EmblaCarousel');
            return;
          }

          emblaNode.dataset.emblaInitialized = 'true';

          const sectionId = emblaNode.dataset.sectionId;
          const dotsNode = document.querySelector('[data-dots-for="' + sectionId + '"]');
          if (dotsNode) {
            const dots = embla.scrollSnapList().map(() => {
              const dot = document.createElement('button');
              dot.className = 'embla__dot';
              dot.type = 'button';
              return dot;
            });

            dotsNode.append(...dots);

            const selectDot = () => {
              const selected = embla.selectedScrollSnap();
              dots.forEach((dot, index) => {
                dot.classList.toggle('embla__dot--selected', index === selected);
              });
            };

            dots.forEach((dot, index) => {
              dot.addEventListener('click', () => embla.scrollTo(index));
            });

            embla.on('select', selectDot);
            selectDot();
          }

          let autoplayInterval = null;
          const startAutoplay = () => {
            if (autoplayInterval) {
              clearInterval(autoplayInterval);
            }
            autoplayInterval = setInterval(() => {
              if (embla.canScrollNext()) {
                embla.scrollNext();
              } else if (loop) {
                embla.scrollTo(0);
              }
            }, 7000);
          };

          const stopAutoplay = () => {
            if (autoplayInterval) {
              clearInterval(autoplayInterval);
              autoplayInterval = null;
            }
          };

          startAutoplay();

          emblaNode.addEventListener('mouseenter', stopAutoplay);
          emblaNode.addEventListener('mouseleave', startAutoplay);
          emblaNode.addEventListener('pointerdown', stopAutoplay);
          emblaNode.addEventListener('pointerup', () => {
            setTimeout(startAutoplay, 1000);
          });
        } catch (error) {
          console.error('Error initializing EmblaCarousel:', error);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initEmbla);
    } else {
      setTimeout(initEmbla, 50);
    }

    if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function(event) {
        const emblaNodes = document.querySelectorAll('.b2b-hero-embla');
        emblaNodes.forEach(function(node) {
          node.dataset.emblaInitialized = 'false';
        });
        setTimeout(initEmbla, 100);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initFAQ() {
      const section = document.querySelector('.faq-section');
      if (!section) return;

      const filterBtns = section.querySelectorAll('.faq-filter-btn');
      const sections = section.querySelectorAll('.faq-category-section');
      const details = section.querySelectorAll('.faq-details');

      filterBtns.forEach(btn => {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          const targetId = this.getAttribute('href');
          const targetElement = document.querySelector(targetId);
          
          if (targetElement) {
            const headerOffset = 120;
            const elementPosition = targetElement.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
              top: offsetPosition,
              behavior: "smooth"
            });
            
            filterBtns.forEach(b => b.classList.remove('active-filter'));
            this.classList.add('active-filter');
          }
        });
      });

      const observerOptions = {
        root: null,
        rootMargin: '-20% 0px -70% 0px',
        threshold: 0
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const id = entry.target.getAttribute('id');
            const activeBtn = section.querySelector(`.faq-filter-btn[href="#${id}"]`);

            if (activeBtn) {
              filterBtns.forEach(btn => btn.classList.remove('active-filter'));
              activeBtn.classList.add('active-filter');
            }
          }
        });
      }, observerOptions);

      sections.forEach(section => {
        observer.observe(section);
      });

      class Accordion {
        constructor(el) {
          this.el = el;
          this.summary = el.querySelector('summary');
          this.content = el.querySelector('.faq-answer-wrapper');
          this.animation = null;
          this.isClosing = false;
          this.isExpanding = false;
          this.summary.addEventListener('click', (e) => this.onClick(e));
        }

        onClick(e) {
          e.preventDefault();
          this.el.style.overflow = 'hidden';
          if (this.isClosing || !this.el.open) {
            this.open();
          } else if (this.isExpanding || this.el.open) {
            this.shrink();
          }
        }

        shrink() {
          this.isClosing = true;
          const startHeight = `${this.el.offsetHeight}px`;
          const endHeight = `${this.summary.offsetHeight}px`;

          if (this.animation) this.animation.cancel();

          this.animation = this.el.animate({
            height: [startHeight, endHeight]
          }, {
            duration: 300,
            easing: 'cubic-bezier(0.4, 0, 0.2, 1)'
          });

          this.animation.onfinish = () => {
            this.el.removeAttribute('open');
            this.isClosing = false;
            this.animation = null;
            this.el.style.height = '';
            this.el.style.overflow = '';
          };
        }

        open() {
          const others = this.el.closest('.faq-list').querySelectorAll('.faq-details');
          others.forEach(other => {
            if (other !== this.el && other.open) {
              const otherAccordion = other.accordionInstance;
              if (otherAccordion) otherAccordion.shrink();
            }
          });

          this.el.style.height = `${this.el.offsetHeight}px`;
          this.el.setAttribute('open', true);
          window.requestAnimationFrame(() => this.expand());
        }

        expand() {
          this.isExpanding = true;
          const startHeight = `${this.el.offsetHeight}px`;
          const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

          if (this.animation) this.animation.cancel();

          this.animation = this.el.animate({
            height: [startHeight, endHeight]
          }, {
            duration: 300,
            easing: 'cubic-bezier(0.4, 0, 0.2, 1)'
          });

          this.animation.onfinish = () => {
            this.isExpanding = false;
            this.animation = null;
            this.el.style.height = '';
            this.el.style.overflow = '';
          };
        }
      }

      details.forEach(detail => {
        detail.accordionInstance = new Accordion(detail);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFAQ);
    } else {
      setTimeout(initFAQ, 50);
    }

    if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function(event) {
        setTimeout(initFAQ, 100);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
(function() {
  const initFeaturedCollection = () => {
    const sections = document.querySelectorAll('.featured-collection-section');
    
    sections.forEach(section => {
      const emblaNode = section.querySelector('.featured-collection__embla');
      if (!emblaNode) return;

      if (typeof EmblaCarousel === 'undefined') {
        setTimeout(initFeaturedCollection, 100);
        return;
      }

      const prevBtn = section.querySelector('.embla__button--prev');
      const nextBtn = section.querySelector('.embla__button--next');
      const dotsNode = section.querySelector('.featured-collection__dots');

      const embla = EmblaCarousel(emblaNode, {
        loop: false,
        align: 'start',
        containScroll: 'trimSnaps',
        slidesToScroll: 1
      });

      const updateButtons = () => {
        if (prevBtn) {
          prevBtn.style.opacity = embla.canScrollPrev() ? '1' : '0';
          prevBtn.style.pointerEvents = embla.canScrollPrev() ? 'auto' : 'none';
        }
        if (nextBtn) {
          nextBtn.style.opacity = embla.canScrollNext() ? '1' : '0';
          nextBtn.style.pointerEvents = embla.canScrollNext() ? 'auto' : 'none';
        }
      };

      if (prevBtn) prevBtn.addEventListener('click', () => embla.scrollPrev());
      if (nextBtn) nextBtn.addEventListener('click', () => embla.scrollNext());

      embla.on('select', updateButtons);
      embla.on('init', updateButtons);
      embla.on('reInit', updateButtons);
      
      updateButtons();
      
      if (dotsNode) {
        dotsNode.innerHTML = '';
        const scrollTo = (index) => embla.scrollTo(index);
        
        const dots = embla.scrollSnapList().map((_, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.classList.add('featured-collection__dot');
          dot.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none"><circle cx="4.5" cy="4.5" r="4.5" fill="#D9D9D9"/></svg>`;
          dot.addEventListener('click', () => scrollTo(i));
          dotsNode.appendChild(dot);
          return dot;
        });

        const updateDots = () => {
          const selectedIndex = embla.selectedScrollSnap();
          dots.forEach((dot, i) => {
            if (i === selectedIndex) dot.classList.add('featured-collection__dot--selected');
            else dot.classList.remove('featured-collection__dot--selected');
          });
        };

        embla.on('select', updateDots);
        embla.on('init', updateDots);
      }
    });
  };

  document.addEventListener('DOMContentLoaded', initFeaturedCollection);
  document.addEventListener('shopify:section:load', initFeaturedCollection);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products-promo"] && !Shopify.designMode) return;
  try {
    
(function() {
  const initRvCarousel = () => {
    const sections = document.querySelectorAll('.recently-viewed-wrapper');
    
    sections.forEach(section => {
      const emblaNode = section.querySelector('.products-tabs-embla');
      
      if (!emblaNode || emblaNode.dataset.emblaInitialized === 'true') return;

      if (typeof EmblaCarousel === 'undefined') {
        setTimeout(initRvCarousel, 100);
        return;
      }

      try {
        const embla = EmblaCarousel(emblaNode, {
          loop: false,
          align: 'start',
          containScroll: 'trimSnaps',
          slidesToScroll: 1,
          dragFree: false
        });
        
        emblaNode.dataset.emblaInitialized = 'true';

        const prevBtn = section.querySelector('.embla__button--prev');
        const nextBtn = section.querySelector('.embla__button--next');

        const updateButtons = () => {
          if (!prevBtn || !nextBtn) return;
          
          if (embla.canScrollPrev()) {
            prevBtn.style.opacity = '1';
            prevBtn.style.pointerEvents = 'auto';
          } else {
            prevBtn.style.opacity = '0';
            prevBtn.style.pointerEvents = 'none';
          }

          if (embla.canScrollNext()) {
            nextBtn.style.opacity = '1';
            nextBtn.style.pointerEvents = 'auto';
          } else {
            nextBtn.style.opacity = '0';
            nextBtn.style.pointerEvents = 'none';
          }
        };

        if (prevBtn) prevBtn.addEventListener('click', () => embla.scrollPrev());
        if (nextBtn) nextBtn.addEventListener('click', () => embla.scrollNext());

        const dotsNode = section.querySelector('.products-tabs__dots');
        if (dotsNode) {
          dotsNode.innerHTML = '';
          const scrollTo = (index) => embla.scrollTo(index);
          
          const dots = embla.scrollSnapList().map((_, i) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.classList.add('products-tabs__dot');
            dot.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none"><circle cx="4.5" cy="4.5" r="4.5" fill="#D9D9D9"/></svg>`;
            dot.addEventListener('click', () => scrollTo(i));
            dotsNode.appendChild(dot);
            return dot;
          });

          const updateDots = () => {
            const selectedIndex = embla.selectedScrollSnap();
            dots.forEach((dot, i) => {
              if (i === selectedIndex) dot.classList.add('products-tabs__dot--selected');
              else dot.classList.remove('products-tabs__dot--selected');
            });
          };

          embla.on('select', updateDots);
          embla.on('init', updateDots);
        }

        embla.on('select', updateButtons);
        embla.on('init', updateButtons);
        embla.on('reInit', updateButtons);
        updateButtons();

      } catch (err) {
        console.error('RV Slider Error:', err);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRvCarousel);
  } else {
    initRvCarousel();
  }
  
  document.addEventListener('shopify:section:load', function(e) {
     const node = e.target.querySelector('.products-tabs-embla');
     if(node) {
       node.dataset.emblaInitialized = 'false';
       initRvCarousel();
     }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const accordions = document.querySelectorAll('.footer-accordion-btn');

  accordions.forEach(acc => {
    acc.addEventListener('click', function() {
      const arrow = this.querySelector('.footer-arrow');
      if (window.getComputedStyle(arrow).display === 'none') return;

      this.classList.toggle('active');
      const panel = this.nextElementSibling;
      
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initEmbla() {
      const emblaNodes = document.querySelectorAll('.hero-carousel-embla');
      
      if (typeof EmblaCarousel === 'undefined') {
        console.warn('EmblaCarousel is not loaded yet, retrying...');
        setTimeout(initEmbla, 100);
        return;
      }

      emblaNodes.forEach(function(emblaNode) {
        if (emblaNode.dataset.emblaInitialized === 'true') {
          return;
        }

        if (!emblaNode) {
          return;
        }

        try {
          const loop = emblaNode.dataset.emblaLoop === 'true';
          const align = emblaNode.dataset.emblaAlign || 'start';
          const duration = parseInt(emblaNode.dataset.emblaDuration) || 20;
          const slidesToScroll = parseInt(emblaNode.dataset.emblaSlidesToScroll) || 1;
          const dragFree = emblaNode.dataset.emblaDragFree === 'true';

          const embla = EmblaCarousel(emblaNode, {
            loop: loop,
            align: align,
            duration: duration,
            slidesToScroll: slidesToScroll,
            dragFree: dragFree
          });

          if (!embla) {
            console.error('Failed to initialize EmblaCarousel');
            return;
          }

          emblaNode.dataset.emblaInitialized = 'true';

          const sectionId = emblaNode.dataset.sectionId;
          const dotsNode = document.querySelector('[data-dots-for="' + sectionId + '"]');
          if (dotsNode) {
            const dots = embla.scrollSnapList().map(() => {
              const dot = document.createElement('button');
              dot.className = 'embla__dot';
              dot.type = 'button';
              return dot;
            });

            dotsNode.append(...dots);

            const selectDot = () => {
              const selected = embla.selectedScrollSnap();
              dots.forEach((dot, index) => {
                dot.classList.toggle('embla__dot--selected', index === selected);
              });
            };

            dots.forEach((dot, index) => {
              dot.addEventListener('click', () => embla.scrollTo(index));
            });

            embla.on('select', selectDot);
            selectDot();
          }

          let autoplayInterval = null;
          const startAutoplay = () => {
            if (autoplayInterval) {
              clearInterval(autoplayInterval);
            }
            autoplayInterval = setInterval(() => {
              if (embla.canScrollNext()) {
                embla.scrollNext();
              } else if (loop) {
                embla.scrollTo(0);
              }
            }, 7000);
          };

          const stopAutoplay = () => {
            if (autoplayInterval) {
              clearInterval(autoplayInterval);
              autoplayInterval = null;
            }
          };

          startAutoplay();

          emblaNode.addEventListener('mouseenter', stopAutoplay);
          emblaNode.addEventListener('mouseleave', startAutoplay);
          emblaNode.addEventListener('pointerdown', stopAutoplay);
          emblaNode.addEventListener('pointerup', () => {
            setTimeout(startAutoplay, 1000);
          });
        } catch (error) {
          console.error('Error initializing EmblaCarousel:', error);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initEmbla);
    } else {
      setTimeout(initEmbla, 50);
    }

    if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function(event) {
        const emblaNodes = document.querySelectorAll('.hero-carousel-embla');
        emblaNodes.forEach(function(node) {
          node.dataset.emblaInitialized = 'false';
        });
        setTimeout(initEmbla, 100);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
(function() {
  const initProductRecommendations = () => {
    const wrapper = document.querySelector('.product-recommendations-wrapper');
    if (!wrapper) return;

    const url = wrapper.dataset.url;
    if (!url) return;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations-section');
        
        if (recommendations && recommendations.innerHTML.trim().length) {
          wrapper.parentNode.replaceChild(recommendations, wrapper);
          // Initialize embla slider on the newly injected HTML
          setTimeout(initFeaturedCollection, 100);
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const initFeaturedCollection = () => {
    const sections = document.querySelectorAll('.product-recommendations-section');
    
    sections.forEach(section => {
      // Prevent double init
      if (section.dataset.initialized === 'true') return;

      const emblaNode = section.querySelector('.featured-collection__embla');
      if (!emblaNode) return;

      if (typeof EmblaCarousel === 'undefined') {
        setTimeout(initFeaturedCollection, 100);
        return;
      }

      section.dataset.initialized = 'true';

      const prevBtn = section.querySelector('.embla__button--prev');
      const nextBtn = section.querySelector('.embla__button--next');
      const dotsNode = section.querySelector('.featured-collection__dots');

      const embla = EmblaCarousel(emblaNode, {
        loop: false,
        align: 'start',
        containScroll: 'trimSnaps',
        slidesToScroll: 1
      });

      const updateButtons = () => {
        if (prevBtn) {
          prevBtn.style.opacity = embla.canScrollPrev() ? '1' : '0';
          prevBtn.style.pointerEvents = embla.canScrollPrev() ? 'auto' : 'none';
        }
        if (nextBtn) {
          nextBtn.style.opacity = embla.canScrollNext() ? '1' : '0';
          nextBtn.style.pointerEvents = embla.canScrollNext() ? 'auto' : 'none';
        }
      };

      if (prevBtn) prevBtn.addEventListener('click', () => embla.scrollPrev());
      if (nextBtn) nextBtn.addEventListener('click', () => embla.scrollNext());

      embla.on('select', updateButtons);
      embla.on('init', updateButtons);
      embla.on('reInit', updateButtons);
      
      updateButtons();
      
      if (dotsNode) {
        dotsNode.innerHTML = '';
        const scrollTo = (index) => embla.scrollTo(index);
        
        const dots = embla.scrollSnapList().map((_, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.classList.add('featured-collection__dot');
          dot.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none"><circle cx="4.5" cy="4.5" r="4.5" fill="#D9D9D9"/></svg>`;
          dot.addEventListener('click', () => scrollTo(i));
          dotsNode.appendChild(dot);
          return dot;
        });

        const updateDots = () => {
          const selectedIndex = embla.selectedScrollSnap();
          dots.forEach((dot, i) => {
            if (i === selectedIndex) dot.classList.add('featured-collection__dot--selected');
            else dot.classList.remove('featured-collection__dot--selected');
          });
        };

        embla.on('select', updateDots);
        embla.on('init', updateDots);
      }
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    initProductRecommendations();
    initFeaturedCollection();
  });
  
  // Custom event trigger for Shopify editor
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.product-recommendations-wrapper') || e.target.querySelector('.product-recommendations-section')) {
      initProductRecommendations();
      initFeaturedCollection();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-tabs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sections = document.querySelectorAll('.products-tabs-section');
    
    sections.forEach(function(section) {
      const sectionId = section.dataset.sectionId;
      const tabs = section.querySelectorAll('[data-tab-index]');
      const panels = section.querySelectorAll('[data-panel-index]');
      let carousels = {};

      function switchTab(index) {
        tabs.forEach(function(tab, i) {
          if (i === index) {
            tab.classList.add('products-tabs__tab--active');
          } else {
            tab.classList.remove('products-tabs__tab--active');
          }
        });

        panels.forEach(function(panel, i) {
          if (i === index) {
            panel.classList.add('products-tabs__panel--active');
            initCarousel(i);
          } else {
            panel.classList.remove('products-tabs__panel--active');
          }
        });
      }

      function initCarousel(index) {
        const carouselId = 'products-tabs-carousel-' + sectionId + '-' + index;
        const emblaNode = document.getElementById(carouselId);
        
        if (!emblaNode || emblaNode.dataset.emblaInitialized === 'true') {
          return;
        }

        const emblaNodeParent = emblaNode.parentElement;

        if (typeof EmblaCarousel === 'undefined') {
          setTimeout(function() {
            initCarousel(index);
          }, 100);
          return;
        }

        try {
          const loop = emblaNode.dataset.emblaLoop === 'true';
          const align = emblaNode.dataset.emblaAlign || 'start';
          const duration = parseInt(emblaNode.dataset.emblaDuration) || 20;
          const slidesToScroll = parseInt(emblaNode.dataset.emblaSlidesToScroll) || 1;
          const dragFree = emblaNode.dataset.emblaDragFree === 'true';

          const embla = EmblaCarousel(emblaNode, {
            loop: loop,
            align: align,
            duration: duration,
            slidesToScroll: slidesToScroll,
            dragFree: dragFree,
            containScroll: 'trimSnaps'
          });

          if (!embla) {
            return;
          }

          emblaNode.dataset.emblaInitialized = 'true';
          carousels[index] = embla;

          const prevButton = emblaNodeParent.querySelector('.embla__button--prev');
          const nextButton = emblaNodeParent.querySelector('.embla__button--next');

          if (prevButton) prevButton.addEventListener('click', () => embla.scrollPrev());
          if (nextButton) nextButton.addEventListener('click', () => embla.scrollNext());

          const dotsNode = emblaNodeParent.querySelector('.products-tabs__dots');
          if (dotsNode) {
            dotsNode.innerHTML = '';

            const scrollTo = (index) => {
              embla.scrollTo(index);
            };

            const dots = embla.scrollSnapList().map((_, i) => {
              const dot = document.createElement('button');
              dot.type = 'button';
              dot.classList.add('products-tabs__dot');
              dot.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
                  <circle cx="4.5" cy="4.5" r="4.5" fill="#D9D9D9"/>
                </svg>
              `;
              dot.addEventListener('click', () => scrollTo(i));
              dotsNode.appendChild(dot);
              return dot;
            });

            const updateDots = () => {
              const selectedIndex = embla.selectedScrollSnap();
              dots.forEach((dot, i) => {
                if (i === selectedIndex) {
                  dot.classList.add('products-tabs__dot--selected');
                } else {
                  dot.classList.remove('products-tabs__dot--selected');
                }
              });
            };

            embla.on('select', updateDots);
            embla.on('init', updateDots);
          }

          const updateButtons = function() {
            if (prevButton) {
              if (embla.canScrollPrev()) {
                prevButton.style.opacity = '1';
                prevButton.style.pointerEvents = 'auto';
              } else {
                prevButton.style.opacity = '0';
                prevButton.style.pointerEvents = 'none';
              }
            }

            if (nextButton) {
              if (embla.canScrollNext()) {
                nextButton.style.opacity = '1';
                nextButton.style.pointerEvents = 'auto';
              } else {
                nextButton.style.opacity = '0';
                nextButton.style.pointerEvents = 'none';
              }
            }
          };

          embla.on('select', updateButtons);
          embla.on('init', updateButtons);
          embla.on('reInit', updateButtons);
          
          // Initial check
          updateButtons();

        } catch (error) {
          console.error('Error initializing carousel:', error);
        }
      }

      tabs.forEach(function(tab, index) {
        tab.addEventListener('click', function() {
          switchTab(index);
        });
      });

      function initFirstCarousel() {
        const activeTab = section.querySelector('.products-tabs__tab--active');
        if (activeTab) {
          const activeIndex = parseInt(activeTab.dataset.tabIndex);
          initCarousel(activeIndex);
        } else if (tabs.length > 0) {
          initCarousel(0);
        }
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
          setTimeout(initFirstCarousel, 100);
        });
      } else {
        setTimeout(initFirstCarousel, 100);
      }
    });

    if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function(event) {
        const loadedSection = document.querySelector('.products-tabs-section[data-section-id="' + event.detail.sectionId + '"]');
        if (loadedSection) {
          const carouselNodes = loadedSection.querySelectorAll('.products-tabs-embla');
          carouselNodes.forEach(function(node) {
            node.dataset.emblaInitialized = 'false';
          });
          setTimeout(function() {
            const activeTab = loadedSection.querySelector('.products-tabs__tab--active');
            if (activeTab) {
              const activeIndex = parseInt(activeTab.dataset.tabIndex);
              const carouselId = 'products-tabs-carousel-' + loadedSection.dataset.sectionId + '-' + activeIndex;
              const emblaNode = document.getElementById(carouselId);
              if (emblaNode && typeof EmblaCarousel !== 'undefined') {
                const loop = emblaNode.dataset.emblaLoop === 'true';
                const align = emblaNode.dataset.emblaAlign || 'start';
                const duration = parseInt(emblaNode.dataset.emblaDuration) || 20;
                const slidesToScroll = parseInt(emblaNode.dataset.emblaSlidesToScroll) || 1;
                const dragFree = emblaNode.dataset.emblaDragFree === 'true';
                const embla = EmblaCarousel(emblaNode, {
                  loop: loop,
                  align: align,
                  duration: duration,
                  slidesToScroll: slidesToScroll,
                  dragFree: dragFree,
                  containScroll: 'trimSnaps'
                });
                if (embla) {
                  emblaNode.dataset.emblaInitialized = 'true';
                  const prevButton = emblaNode.parentElement.querySelector('.embla__button--prev');
                  const nextButton = emblaNode.parentElement.querySelector('.embla__button--next');
                  if (prevButton) prevButton.addEventListener('click', () => embla.scrollPrev());
                  if (nextButton) nextButton.addEventListener('click', () => embla.scrollNext());
                  
                  const dotsNode = emblaNode.parentElement.querySelector('.products-tabs__dots');
                  if (dotsNode) {
                    dotsNode.innerHTML = '';
                    const scrollTo = (index) => embla.scrollTo(index);
                    const dots = embla.scrollSnapList().map((_, i) => {
                      const dot = document.createElement('button');
                      dot.type = 'button';
                      dot.classList.add('products-tabs__dot');
                      dot.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none"><circle cx="4.5" cy="4.5" r="4.5" fill="#D9D9D9"/></svg>`;
                      dot.addEventListener('click', () => scrollTo(i));
                      dotsNode.appendChild(dot);
                      return dot;
                    });
                    const updateDots = () => {
                      const selectedIndex = embla.selectedScrollSnap();
                      dots.forEach((dot, i) => {
                        if (i === selectedIndex) dot.classList.add('products-tabs__dot--selected');
                        else dot.classList.remove('products-tabs__dot--selected');
                      });
                    };
                    embla.on('select', updateDots);
                    embla.on('init', updateDots);
                  }

                  const updateButtons = () => {
                    if (prevButton) {
                      if (embla.canScrollPrev()) {
                        prevButton.style.opacity = '1';
                        prevButton.style.pointerEvents = 'auto';
                      } else {
                        prevButton.style.opacity = '0';
                        prevButton.style.pointerEvents = 'none';
                      }
                    }
                    if (nextButton) {
                      if (embla.canScrollNext()) {
                        nextButton.style.opacity = '1';
                        nextButton.style.pointerEvents = 'auto';
                      } else {
                        nextButton.style.opacity = '0';
                        nextButton.style.pointerEvents = 'none';
                      }
                    }
                  };
                  embla.on('select', updateButtons);
                  embla.on('init', updateButtons);
                  updateButtons();
                }
              }
            }
          }, 100);
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-slider"] && !Shopify.designMode) return;
  try {
    
(function() {
  const initTestimonials = () => {
    const section = document.querySelector('.testimonials-section');
    if (!section) return;
    const emblaNode = section.querySelector('.testimonials-embla');
    if (!emblaNode) return;
    if (typeof EmblaCarousel === 'undefined') {
      setTimeout(initTestimonials, 100);
      return;
    }
    const viewportNode = emblaNode;
    const prevBtn = section.querySelector('.testimonials-prev');
    const nextBtn = section.querySelector('.testimonials-next');
    const dotsNode = section.querySelector('.testimonials-dots');
    const embla = EmblaCarousel(viewportNode, {
      loop: false,
      align: 'start',
      slidesToScroll: 1,
      containScroll: 'trimSnaps'
    });
    const updateArrows = () => {
      if (!prevBtn || !nextBtn) return;
      prevBtn.style.opacity = embla.canScrollPrev() ? '1' : '0';
      prevBtn.style.pointerEvents = embla.canScrollPrev() ? 'auto' : 'none';
      nextBtn.style.opacity = embla.canScrollNext() ? '1' : '0';
      nextBtn.style.pointerEvents = embla.canScrollNext() ? 'auto' : 'none';
    };
    if (prevBtn) prevBtn.addEventListener('click', embla.scrollPrev);
    if (nextBtn) nextBtn.addEventListener('click', embla.scrollNext);
    embla.on('select', updateArrows);
    embla.on('init', updateArrows);
    embla.on('reInit', updateArrows);
    if (dotsNode) {
      const scrollSnaps = embla.scrollSnapList();
      dotsNode.innerHTML = '';
      const dots = scrollSnaps.map((_, index) => {
        const dot = document.createElement('button');
        dot.classList.add('testimonial-dot');
        dot.addEventListener('click', () => embla.scrollTo(index));
        dotsNode.appendChild(dot);
        return dot;
      });
      const updateDots = () => {
        const selectedIndex = embla.selectedScrollSnap();
        dots.forEach((dot, index) => {
          if (index === selectedIndex) dot.classList.add('testimonial-dot--active');
          else dot.classList.remove('testimonial-dot--active');
        });
      };
      embla.on('select', updateDots);
      embla.on('init', updateDots);
    }
  };
  document.addEventListener('DOMContentLoaded', initTestimonials);
  document.addEventListener('shopify:section:load', initTestimonials);
})();

  } catch(e) { console.error(e); }
})();
})();
